import type { SiteStudyAreaScope } from '../types/siteStudyArea';

/** Read the frozen, geometry-bound gross area; it never establishes usable area. */
export function studyAreaGrossAcres(scope?: Partial<SiteStudyAreaScope> | null): number | undefined {
  return scope?.schemaVersion === 1 && scope.areaMethodVersion === 'spherical-mean-radius-6371000-v1'
    && typeof scope.geometryHash === 'string' && scope.geometryHash.length > 0
    && typeof scope.selectionHash === 'string' && scope.selectionHash.length > 0
    && Number.isInteger(scope.polygonCount) && scope.polygonCount! > 0
    && typeof scope.grossAreaAcres === 'number' && Number.isFinite(scope.grossAreaAcres) && scope.grossAreaAcres > 0
    ? scope.grossAreaAcres : undefined;
}
